export default "__VITE_ASSET__BuZAj9Wl__"